import { NgModule } from '@angular/core';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { ROUTES } from './app.routes'; // import app routes

// defined the app routing module
@NgModule({
  // not use hash (#), and pre load all modules
  imports: [
    RouterModule.forRoot(ROUTES, { useHash: false, scrollPositionRestoration: 'top', preloadingStrategy: PreloadAllModules })

  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
// export app routing Module
export class AppRoutingModule {
}
